/**
 * GalleryView Component
 * Displays all artwork images in a grid layout (Show All section)
 */
import React from 'react';
import Image from 'next/image';
import { Eye } from 'lucide-react';

interface ArtImage {
  mainSrc: string;
  alt: string;
  width: number;
  height: number;
  title: string;
  dimensions: string;
}

interface GalleryViewProps {
  artImages: ArtImage[] | undefined;
  showAllSection: boolean;
  onImageClick: (src: string) => void;
}

export const GalleryView: React.FC<GalleryViewProps> = ({
  artImages,
  showAllSection,
  onImageClick,
}) => {
  return (
    <div
      id="show-all-section"
      className={`rounded-md bg-white flex flex-col justify-between relative transition-all duration-500 ease-in-out overflow-hidden ${
        showAllSection ? 'max-h-[10000px] p-[15px] opacity-100 mb-[12px] pt-4' : 'max-h-0 opacity-0'
      }`}
    >
      <div className="content-section">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 font-mono text-[10px] fade-in-up">
          <div>
            <div className="mt-0">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                  <h3 className="text-[10px] font-mono text-gray-400 mb-2">
                    [ VISIONS - AUCTION ARTWORKS / CHAPTER #1 ]
                  </h3>
                  <div>
                    <h3 className="text-[10px] static lg:absolute lg:right-0 lg:top-0 font-mono text-gray-400 mb-2">
                      20 / 420 PHYSICAL ARTWORKS
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mt-8 w-full p-10">
          {artImages &&
            artImages.map((art, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="mb-6">
                  <Image
                    src={art.mainSrc}
                    alt={art.alt}
                    width={200}
                    height={150}
                    className="w-full h-auto object-contain max-h-[74vh]"
                    unoptimized={true}
                  />
                </div>
                <div className="text-center uppercase mb-4 text-[14px] font-bold">
                  {art.title}
                </div>
                <div className="text-center font-mono mb-3 text-[14px]">
                  {art.dimensions}
                </div>
                <div className="flex justify-center mt-1">
                  <button
                    className="text-center cursor-pointer focus:outline-none hover:opacity-70 transition-opacity"
                    onClick={() => onImageClick(art.mainSrc)}
                    aria-label={`View ${art.title} fullscreen`}
                  >
                    <Eye className="w-3 h-3" />
                  </button>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};